import { Checkbox, Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';

let BsPreparationDryingEquipmentSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection>
    <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
    <FieldSet>
      <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
      <Field input={<Checkbox />} name="Preparation.ContainsGypsum" />
    </FieldSet>
    <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" />
  </ListFieldSection>
);

BsPreparationDryingEquipmentSection = withInjectedProps(BsPreparationDryingEquipmentSection);

export { BsPreparationDryingEquipmentSection };
export default BsPreparationDryingEquipmentSection;
